const AUTH = Object.freeze({
  Login: {
    path: '/login',
    title: 'Login',
  },
  ForgotPassword: {
    path: '/forgot-password',
    title: 'Forgot Password',
  },
});

const SERVICE = Object.freeze({
  PrivacyPolicy: {
    path: 'privacy-policy',
    title: 'Privacy policy',
  },
  TermsOfService: {
    path: 'terms-of-service',
    title: 'Terms of service',
  },
});

const DASHBOARD = Object.freeze({
  Dashboard: {
    path: '/dashboard',
    title: 'Dashboard',
  },
  WeeklyMenu: {
    path: '/weekly-menu',
    title: 'Edit weekly menu',
  },
});

const RECIPES = Object.freeze({
  Recipes: {
    path: '/recipes',
    title: 'Recipes',
  },
  CreateRecipe: {
    path: '/create',
    title: 'Create recipe',
  },
  EditRecipe: {
    path: '/:id/edit',
    title: 'Edit recipe',
  },
  Recipe: {
    path: '/:id',
    title: 'Recipe',
  },
});

const ADMINS = Object.freeze({
  Admins: {
    path: '/admins',
    title: 'Admins',
  },
  CreateAdmin: {
    path: '/create',
    title: 'Create profile',
  },
  EditAdmin: {
    path: '/:id/edit',
    title: 'Edit profile',
  },
});

const USERS = Object.freeze({
  Users: {
    path: '/users',
    title: 'Users',
  },
  User: {
    path: '/:id',
    title: 'User',
  },
});

const REVIEWS = Object.freeze({
  Reviews: {
    path: '/reviews',
    title: 'Reviews',
  },
});

const SETTINGS = Object.freeze({
  Settings: {
    path: '/settings',
    title: 'Settings',
  },
});

export const ROUTE = Object.freeze({
  ...AUTH,
  ...SERVICE,
  ...DASHBOARD,
  ...RECIPES,
  ...ADMINS,
  ...USERS,
  ...REVIEWS,
  ...SETTINGS,
});

export const HISTORY = Object.freeze({
  [ROUTE.Dashboard.title]: [ROUTE.Dashboard],
  [ROUTE.Recipes.title]: [ROUTE.Recipes],
  [ROUTE.Admins.title]: [ROUTE.Admins],
  [ROUTE.Users.title]: [ROUTE.Users],
  [ROUTE.Reviews.title]: [ROUTE.Reviews],
  [ROUTE.CreateRecipe.title]: [ROUTE.Recipes, ROUTE.CreateRecipe],
  [ROUTE.EditRecipe.title]: [
    ROUTE.Recipes,
    { title: ROUTE.Recipe.title, path: '/recipes/:id' },
    ROUTE.EditRecipe,
  ],
  [ROUTE.Recipe.title]: [ROUTE.Recipes, ROUTE.Recipe],
  [ROUTE.WeeklyMenu.title]: [ROUTE.Dashboard, ROUTE.WeeklyMenu],
  [ROUTE.CreateAdmin.title]: [ROUTE.Admins, ROUTE.CreateAdmin],
  [ROUTE.EditAdmin.title]: [ROUTE.Admins, ROUTE.EditAdmin],
  [ROUTE.Settings.title]: [ROUTE.Settings],
  [ROUTE.User.title]: [ROUTE.Users, ROUTE.User],
});

export const NAV_ROUTES = [
  { to: ROUTE.Dashboard.path, title: 'Dashboard' },
  { to: ROUTE.Recipes.path, title: 'Recipes' },
  { to: ROUTE.Admins.path, title: 'Admins' },
  { to: ROUTE.Users.path, title: 'Users' },
  { to: ROUTE.Reviews.path, title: 'Reviews' },
  { to: ROUTE.Settings.path, title: 'Settings' },
];
